export default __webpack_public_path__ + "locales/lo-LA/Profile.json?hash=aee173d69aec90566a9ef42feb89722f";